// Généré par maquettes/outils/dc2react.py à partir de la maquette. Ne pas modifier à la main :
// changer maquettes/src puis relancer le script.
import React from 'react';

export default function Faq({ v }) {
  return (
    <section className="m-sec" id="faq" style={{ maxWidth: "880px", margin: "0 auto", padding: "96px 24px", display: "flex", flexDirection: "column", gap: "20px" }}>
      <h2 style={{ margin: "0", fontSize: "clamp(32px, 3.4vw, 48px)", fontWeight: "800", fontStretch: "80%", lineHeight: "1.04" }}>
        Questions fréquentes
      </h2>
      <div style={{ borderTop: "1px solid #CDD1D6" }}>
        {(v.faq || []).map((q, $index) => (
          <React.Fragment key={$index}>
            <div style={{ borderBottom: "1px solid #CDD1D6" }}>
              <button type="button" onClick={q.toggle} aria-expanded={q.open} style={{ width: "100%", minHeight: "60px", padding: "16px 0", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "16px", background: "transparent", border: "0", fontFamily: "inherit", fontSize: "18px", fontWeight: "700", color: "#15171A", textAlign: "left", cursor: "pointer" }}>
                {`${q.q}`}
                <span style={{ flex: "none", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "22px", color: v.accent }}>
                  {`${q.icon}`}
                </span>
              </button>
              {q.open && (
                <>
                  <p style={{ margin: "0", padding: "0 0 18px", fontSize: "16px", color: "#30353C", animation: "fadeUp 240ms ease both" }}>
                    {`${q.a}`}
                  </p>
                </>
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}
